import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export { CONTENT_GAP } from '@bedrock-rdk/constants';
